import { render, staticRenderFns } from "./ClientOrders.vue?vue&type=template&id=4a42258e&scoped=true&"
import script from "./ClientOrders.vue?vue&type=script&lang=js&"
export * from "./ClientOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a42258e",
  null
  
)

export default component.exports